export default class ManualDomiciliation {
  constructor ({ amount = 0, currency = null, bank_account_owner_name = null, iban = null, bic = null } = {}) {
    this.amount = amount
    this.currency = currency
    this.bank_account_owner_name = bank_account_owner_name
    this.iban = iban
    this.bic = bic
  }

  get to_database () {
    return this.amount ? { ...this } : {}
  }
}
